import React from 'react'
import { Tooltip } from 'antd'
import { colors, Box, BoxProps } from '@weareberyl/design-system'
import { capitalCase } from 'change-case'

import electricIcon from '~/images/electric.svg'
import { FrameType } from '~/gql/generated/graphql'
import { getVehicleName } from '.'

type Props = {
  frameType: FrameType
} & BoxProps

class FrameTypeIcon extends React.PureComponent<Props> {
  render() {
    const { frameType, ...props } = this.props
    const vehicleName = getVehicleName(frameType)
    const frameTypeTitle = capitalCase(frameType ?? '')

    switch (vehicleName) {
      case 'e-Bike':
      case 'e-Cargo Bike':
      case 'e-Scooter':
        return (
          <Tooltip title={frameTypeTitle}>
            <Box
              mr={2}
              height={18}
              width={18}
              borderRadius="100%"
              bg={colors.lake}
              {...props}
            >
              <img
                alt="electric"
                style={{
                  height: 18,
                  padding: 2,
                }}
                src={electricIcon}
              />
            </Box>
          </Tooltip>
        )

      default:
        return null
    }
  }
}

export default FrameTypeIcon
